import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import Modal from 'bundles/apex/playbooks/config/tasks/modal';

import { getPlaybookRecordType } from 'bundles/apex/playbooks/config/helpers';
import { titleize } from 'helpers/formatters/string_formats';

export default function AddField({ playbook, stage, status }) {
  const [showModal, setShowModal] = useState();

  return <React.Fragment>
    <AddControl id="add-deal-task" onClick={() => setShowModal(true)}>
      {titleize(getPlaybookRecordType(playbook))} Task
    </AddControl>

    {!showModal ? null :
      <Modal
        className="playbook-task-modal"
        playbook={playbook}
        stage={stage}
        status={status}
        onHide={() => setShowModal(false)}
      />
    }
  </React.Fragment>;
}

AddField.propTypes = {
  playbook: PropTypes.object,
  stage: PropTypes.object,
  status: PropTypes.object,
};
